const changeSlide = () => {
  const $trigger = $('.js-main-pdp .js-product-main-select');
  const $slider = $('.js-main-pdp .js-product-slider-items');

  $trigger.on('change', function() {
    const $this = $(this);
    const $currentVariant = $this.find('option:selected');
    const $currentSlide = $slider.find(`[data-variants*="${$currentVariant.val()}"]`).eq(0).closest('.slick-slide');
    const slideIndex = $currentSlide.data('slick-index');

    if (! $currentSlide.hasClass('slick-current')) {
      $slider.slick('slickGoTo', slideIndex);
    }
  });
}

changeSlide();
